import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable, Injector } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { DeviceKS } from '@providers/device-ks/device-ks';
import { Mxp } from '@providers/mxp/mxp';
import { includes, some } from 'lodash-es';
import { from, Observable, throwError } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';

import { environment } from '../../environments/environment';
import { CountryService } from '../country/country';
import { LocalStorage } from '../local-storage/local-storage';
import { User } from '../user/user';

@Injectable()
export class TokenInterceptor implements HttpInterceptor {
  initialTokenPromise: Promise<string>;

  omitTokenPaths = ['password/reset', 'accounts/signin', 'accounts/signup'];
  constructor(
    private mxp: Mxp,
    private country: CountryService,
    private deviceKS: DeviceKS,
    private localStorage: LocalStorage,
    private translate: TranslateService,
    public user: User
  ) {}

  mustOmitToken(path: string) {
    return some(this.omitTokenPaths, el => includes(path, el));
  }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const parsedUrl = new URL(environment.api);
    if (request.url.search(parsedUrl.origin) === 0) {
      if (!this.initialTokenPromise) {
        this.initialTokenPromise = this.localStorage.getItem('tokenUser');
      }

      return from(this.initialTokenPromise).pipe(
        switchMap(tokenUser => this.handleApiRequest(request, next, tokenUser))
      );
    } else {
      return next.handle(request);
    }
  }

  handleApiRequest(
    request: HttpRequest<any>,
    next: HttpHandler,
    localStorageTokenUser?: string
  ): Observable<HttpEvent<any>> {
    let tokenUser: string | undefined;

    if (this.mustOmitToken(request.url)) {
      tokenUser = undefined;
    } else {
      tokenUser = this.user.currentUser ? this.user.currentUser.token : localStorageTokenUser;
    }
    const currentLang = this.translate.currentLang ? this.translate.currentLang.slice(0, 2) : undefined;
    const newHeaders = {
      language: currentLang,
      country: this.country.currentCountry,
      platform: 'smart_tv',
      device: this.deviceKS.name || 'lg',
      distinctid: this.mxp.distinct_id.value,
    };
    request = tokenUser
      ? request.clone({
          setHeaders: {
            Authorization: `token ${tokenUser}`,
            ...newHeaders,
          },
        })
      : request.clone({
          setHeaders: newHeaders,
        });

    const handler = next.handle(request).pipe(
      catchError((error, caught) => {
        if (error.status === 401 || error.status === 403) {
          // this.store.dispatch(new fromAuth.LogoutAction());
          return throwError(error);
        } else {
          return throwError(error);
        }
      })
    );

    return handler;
  }
}
